import { useCode } from '@/src/hooks/useCode'
import { getError, showToast } from '@/src/utils'
import { useAppSelector } from '@store/hooks'
import { Codes } from '@type/config.type'
import { FormButton, RadioBtn } from '@ui'
import { Box, Text } from 'grommet'
import { useEffect, useState } from 'react'
import { IoArrowBack } from 'react-icons/io5'
import { useParams } from 'react-router-dom'

type Props = {
  setSteps: (arg: string) => void
}

type CardProps = {
  handleOnChange: (arg: string) => void
  checked: boolean
  setSelectedCode: (arg: string) => void
} & Codes

export const CodeCard = ({ description, name, handleOnChange, checked, setSelectedCode }: CardProps) => {
  return (
    <label className={`flex items-center gap-4 px-4 py-3 cursor-pointer transition-all`}>
      <RadioBtn
        checked={checked}
        name="code"
        onChange={val => {
          handleOnChange(val.target?.value)
          setSelectedCode(val.target?.value)
        }}
        type="radio"
        value={name}
      />
      <div className="flex gap-0.5 flex-col">
        <span className="text-gray-800 font-medium">{name}</span>
        <span className="text-sm text-gray-500">{description}</span>
      </div>
    </label>
  )
}

export const CodeStep = ({ setSteps }: Props) => {
  const { patientId } = useParams()
  const [selectedCode, setSelectedCode] = useState('')

  const { codes } = useAppSelector(state => state.config)

  const { codes: data, addCode } = useCode({ patient_id: patientId || '' })

  useEffect(() => {
    const existing = data?.[0]?.attributes?.name
    if (existing) setSelectedCode(existing)
  }, [data])

  const handleNext = () => {
    setSteps('medications')
  }

  const handleOnChange = async (val: string) => {
    const payload = {
      data: {
        attributes: codes.find(({ name }) => name === val),
        relationships: {
          patient: {
            data: {
              id: patientId,
              type: 'patient'
            }
          }
        },
        type: 'code'
      }
    }

    try {
      await addCode(payload)
      showToast('Code updated successfully')
    } catch (error) {
      getError(error)
    }
  }

  const handlePrevious = () => {
    setSteps('allergies')
  }
  return (
    <div className="flex flex-1 flex-col overflow-auto">
      <div className="flex flex-1 flex-col overflow-auto gap-4 pb-4">
        <Box direction="row" justify={'between'} margin={{ bottom: '16px' }} width={'100%'}>
          <Text margin={{ bottom: '2px' }} style={{ fontSize: '18px', fontWeight: 500 }}>
            Codes
          </Text>
        </Box>
        <div className="flex flex-col divide-y divide-gray-200">
          {codes?.map(item => (
            <CodeCard
              key={item.name}
              {...item}
              checked={selectedCode === item.name}
              handleOnChange={handleOnChange}
              setSelectedCode={setSelectedCode}
            />
          ))}
        </div>
      </div>

      <FormButton
        cancel="Back"
        justify="between"
        leftIcon={<IoArrowBack />}
        onClick={handleNext}
        onClose={handlePrevious}
        submit="Next"
      />
    </div>
  )
}

export default CodeStep
